import { useStore } from '@nanostores/react';
import { PropsWithChildren } from 'react';
import { SessionProvider } from '~/features/auth/context/Session';
import { OrganisationProvider } from '~/hooks/useOrganisation';
import { RadixThemeProvider } from '~/lib/radix/RadixThemeProvider';
import { ReactQueryCustomProvider } from '~/lib/tanstackQuery/Provider';
import MultipleAPIClientsApp from '~/services';
import { interfaceStore } from '~/stores/interface';
import { BreakpointProvider } from '~/utils/breakpoints';

export default function AppProviders({ children }: PropsWithChildren) {
  const appearanceMode = useStore(interfaceStore.appearanceMode);
  return (
    <SessionProvider>
      <MultipleAPIClientsApp>
        <ReactQueryCustomProvider>
          <OrganisationProvider>
            <BreakpointProvider>
              <RadixThemeProvider appearance={appearanceMode}>{children}</RadixThemeProvider>
            </BreakpointProvider>
          </OrganisationProvider>
        </ReactQueryCustomProvider>
      </MultipleAPIClientsApp>
    </SessionProvider>
  );
}
